// extracted by mini-css-extract-plugin
module.exports = {"root":"TimeSquare_root__2E36l"};